const { addTrailingSlash } = require('./addTrailingSlash')

const locale = process.env.GATSBY_INTL_LOCALE
const env = process.env.GATSBY_ENV
const useLocalePathPrefix = process.env.GATSBY_USE_LOCALE_PATH_PREFIX === 'true'
const useAppPathPrefix = process.env.GATSBY_USE_APP_PATH_PREFIX === 'true'

const getWebsiteUrl = () => {
  const baseUrl = addTrailingSlash(process.env.GATSBY_KTO_URL)

  if (env === 'local') return baseUrl

  if (!useLocalePathPrefix && !useAppPathPrefix) 
    return baseUrl

  const hasLocalePrefix = baseUrl.includes(`/${locale}/`)
  const hasAppPrefix = baseUrl.includes('/app/')

  if (useLocalePathPrefix && !hasLocalePrefix && !useAppPathPrefix) {
    return `${baseUrl}${locale}/`
  } 
  
  if (!useLocalePathPrefix && useAppPathPrefix && !hasAppPrefix) {
    return `${baseUrl}app/`
  } 

  if (useLocalePathPrefix && !hasLocalePrefix && useAppPathPrefix && !hasAppPrefix) {
    return `${baseUrl}app/${locale}/`
  }

  return baseUrl
}

const getWebsitePathPrefix = () => {
  if (env === 'local') return ''

  if (useLocalePathPrefix && useAppPathPrefix) 
    return `app/${locale}`

  if (useLocalePathPrefix && !useAppPathPrefix) 
    return locale

  if (!useLocalePathPrefix && useAppPathPrefix) 
    return 'app'

  return ''
}

const getPathNavigation = (path) => {
  let newPath = path

  if (useLocalePathPrefix) 
    newPath = `/${locale}${path}`

  return newPath
} 

const websitePathPrefix = getWebsitePathPrefix()
const pathPrefix = `/${websitePathPrefix}`
const bucketPrefix = websitePathPrefix

module.exports = { 
  useLocalePathPrefix, 
  useAppPathPrefix, 
  pathPrefix,
  bucketPrefix,
  getWebsiteUrl, 
  getWebsitePathPrefix,
  getPathNavigation 
}
